export default class extends Controller {
  connect() {
    this.hide = this.hide
    App.Helpers.listenToCustomEvent(document, "assets--hide-group", this.hideGroup.bind(this))
    App.Helpers.listenToCustomEvent(document, "assets--show-group", this.showGroup.bind(this))
  }

  hideGroup(event) {
    this.hide = true
  }

  showGroup(event) {
    this.hide = false
  }

  set hide(val) {
    this.data.set("hide", val ? "1" : null)
    App.Helpers[val ? "hideElement" : "showElement"](this.element)
  }

  get hide() {
    return App.Helpers.isTruthy(this.data.get("hide"))
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-group-controller.js